import { Col, Modal, Row, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";

import { getNomeEmpresa, getNomeLocal, getStatusFilial } from "../../../services/auth";
import SelecoesEmpresa from "../../../pages/login/selecaoEmpresa";

export default function ModalEmpresaFilial({ exibirModalEmpresaFilial, fecharModalEmpresaFilial }) {

    const onCloseModal = () => {
        fecharModalEmpresaFilial();
    };

    return (
        <Modal centered
            title="Empresas/Filiais"
            open={exibirModalEmpresaFilial}
            onCancel={onCloseModal}
            onOk={onCloseModal}
            width={600}
            destroyOnClose
            okText={
                <>
                    <CheckOutlined /> Alterar Acesso
                </>
            }
            footer={null}
            maskClosable={false}
        >
            <Row align='middle' gutter={[0, 8]}>
                <Col span={24}>
                    <Typography.Text>
                        Você está acessando: <b>{`${getNomeEmpresa()} / ${getNomeLocal()}${!getStatusFilial() ? ' (INATIVO)' : ''}`}</b>
                    </Typography.Text>
                </Col>
            </Row>
            <SelecoesEmpresa veioDaHome={true} exibirModal={exibirModalEmpresaFilial} />
        </Modal>
    )
}